export const ConditionModel = {
    parameter: "",
    comparisonOp: "",
    value: [],
    ruleId: 0,
    conditionId: 0
}

export const ConditionComparisonOpList = [
      { text: "Равно  =", value: "==" },
      { text: "Больше или Равно  >=", value: ">=" },
      { text: "Меньше или Равно  <=", value: "<=" },
      { text: "Больше  >", value: ">" },
      { text: "Меньше  <", value: "<" },
      { text: "Не равно  <>", value: "!=" },
    ]

// export const ConditionParameterList = [
//     { text: "Регистрация", value: "registration" },
//     { text: "Код товара", value: "product_code" },
//     { text: "Сумма", value: "amount" },
//     { text: "Фиксированная дата", value: "fixed_date" },
//     // { text: "Точка обслуживания", value: "point" },
//   ]

export const ConditionParameter = { text: "Неизвестный", value: "unknown" }

export const ConditionControlEnum = { checkBox: "CHECKBOX", textField: "FIELD", list: "LIST", textDateField: "DATEFIELD" }
